import { render, staticRenderFns } from "./create-password-forgot.vue?vue&type=template&id=fe5e6c8e&"
import script from "./create-password-forgot.vue?vue&type=script&lang=js&"
export * from "./create-password-forgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports